export default ["dev","01-news.html","about.html","career.html","catalog.html","contacts.html","development.html","error.html","faq.html","gallery-one.html","gallery.html","growth.html","index.html","jobs-one.html","jobs.html","news-one.html","news.html","pharmacovigilance.html","product-card.html","productions.html","search-not-found.html","search.html"]


// WEBPACK FOOTER //
// app/scripts/files.js